import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const DashboardContainer = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
  flex: 1;

  iframe {
    width: 100%;
    height: 100%;
  }
`;
